/* eslint-disable */
export const setPropsForClient = (propObj) => `<script>window.__EXPERIENCE_PROPS__ = ${JSON.stringify(propObj)};</script>`;

export const getServerProps = () => window.__EXPERIENCE_PROPS__ || {};
